import { IAppState } from '../../redux';
import { selectBetInputError } from '../betPosition';

export function selectIsPublicationAvailable(state: IAppState): boolean {
  const {
    checkoutInfo: { isPurchaseAvailable },
  } = state;

  const betError = selectBetInputError(state);

  return isPurchaseAvailable && !betError;
}
